import { useNavigate } from "react-router-dom";
import { webPaths } from "../routes/pageRoutes";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div class="ct_page_not_found_bg">
      <div class="ct_page_not_found_section">
        <h1 class="ct_page_not_found_error">404</h1>
        <div class="ct_page_not_found_page">
          Oops! The page you’re looking for can’t be found.
        </div>

        <button className="ct_green_bnt px-5" onClick={() => {
            navigate(webPaths?.WebHome)
        }}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
